import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00dfddab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attribute-item-header" }
const _hoisted_2 = {
  key: 0,
  class: "attribute-item-actions"
}
const _hoisted_3 = {
  key: 0,
  class: "option-list"
}
const _hoisted_4 = {
  key: 0,
  class: "option-item"
}
const _hoisted_5 = {
  key: 1,
  class: "option-item"
}

import {mdiLoading, mdiMenuDown, mdiMenuUp} from "@mdi/js";

import {ref, watch} from 'vue';
import ProductAttributeComponent from "@/Components/ProductAttributes/ProductAttributeComponent.vue";
import ProductAttribute from "@/types/ProductAttribute";
import ProductAttributeOption from "@/types/ProductAttributeOption";
import Messages from "@/Components/General/Messages.vue";
import ProductFilter from "@/Components/Product/ProductFilter.vue";
import Card from "@/Components/General/Card.vue";
import ProductList from "@/Components/Product/ProductList.vue";
import Button from "@/Components/Buttons/Button.vue";
import Modal from "@/Components/General/Modal.vue";
import {useForm} from "@inertiajs/inertia-vue3";
import {computed} from "@vue/reactivity";
import SvgIcon from "@jamescoyle/vue-icon";
import ValidationFormErrors from "@/Components/Forms/ValidationFormErrors.vue";
import {Inertia} from "@inertiajs/inertia";
import ProductAttributeOptionComponent from "@/Components/ProductAttributes/ProductAttributeOptionComponent.vue";
import ProductOption from "@/types/ProductAttributeOption";
import Confirm from "@/Components/General/Confirm.vue";
import ProductDeleteModal from "@/Components/Product/ProductDeleteModal.vue";
import {useStore} from "@/stores/main";



import AppLayoutVue from "@/Layouts/AppLayout.vue";


const __default__ = {
  layout: AppLayoutVue,

}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ProductAttributeComponent',
  props: {
    attribute: {},
    collapsed: { type: Boolean }
  },
  emits: ["toggleAttribute"],
  setup(__props: any, { emit }) {

const props = __props;



const store = useStore();

const form = useForm<any>({
  name: props.attribute.name,
})

const deleteAttributeConfirm = ref(false);

const updateAttribute = () => {

  form.post(route("attributes.update", {attribute: props.attribute.id}), {
    preserveScroll: true,
    onSuccess: (page: any) => {
      form.clearErrors();
    },
  })
};


//options
const optionsForm = useForm<any>({
  options: props.attribute.options
})
const addOption = () => {
  if (props.collapsed) {
    emit("toggleAttribute", props.attribute)
  }
  optionsForm.data().options.push({value: '', attribute_id: props.attribute.id, wc_id: null, id: null});
};

const removeOption = (optionIndex: number | string) => {
  optionsForm.data().options.splice(optionIndex, 1);

};

watch(() => optionsForm.data(), (v: any) => {
  optionsForm.clearErrors()
  if (!optionsForm.data().options.length) {
    emit("toggleAttribute", props.attribute)
  }
}, {deep: true})

const updateAttributeOptions = () => {
  optionsForm.post(route('attribute-options.store', {attribute: props.attribute.id}), {
    preserveScroll: true,
    preserveState: true,
    onSuccess: (page: any) => {
    },
  })
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createElementBlock("li", {
      key: _ctx.attribute.id,
      class: "attribute-item"
    }, [
      _createVNode(ValidationFormErrors, {
        errors: _unref(form).errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "toggle"),
        _withDirectives(_createElementVNode("input", {
          class: "attribute-item-name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event))
        }, null, 512), [
          [_vModelText, _unref(form).name]
        ]),
        (_unref(store).isAdmin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(Button, {
                class: "button-with-icon",
                color: "primary",
                type: "a",
                onClick: addOption
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Nytt valg ")
                ]),
                _: 1
              }),
              _createVNode(Button, {
                class: "button-with-icon",
                color: "primary",
                type: "a",
                disabled: _unref(form).processing,
                onClick: updateAttribute
              }, {
                default: _withCtx(() => [
                  (_unref(form).processing)
                    ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                        key: 0,
                        class: "animate-spin",
                        type: "mdi",
                        path: _unref(mdiLoading)
                      }, null, 8, ["path"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Oppdater ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(Button, {
                class: "button-with-icon",
                color: "red",
                type: "a",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteAttributeConfirm.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Slett ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      ((!_ctx.collapsed ))
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_unref(optionsForm).options.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                  _createVNode(ValidationFormErrors, {
                    errors: _unref(optionsForm).errors
                  }, null, 8, ["errors"])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(optionsForm).options, (option, index) => {
              return (_openBlock(), _createBlock(ProductAttributeOptionComponent, {
                key: option.id,
                modelValue: option
              }, {
                "remove-option": _withCtx(() => [
                  (_unref(store).isAdmin)
                    ? (_openBlock(), _createBlock(Button, {
                        key: 0,
                        class: "button-with-icon",
                        color: "red",
                        type: "a",
                        onClick: ($event: any) => (removeOption(index))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Fjern ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["modelValue"]))
            }), 128)),
            (_unref(optionsForm).options.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                  (_unref(store).isAdmin)
                    ? (_openBlock(), _createBlock(Button, {
                        key: 0,
                        class: "button-with-icon",
                        color: "primary",
                        type: "a",
                        disabled: _unref(optionsForm).processing,
                        onClick: updateAttributeOptions
                      }, {
                        default: _withCtx(() => [
                          (_unref(optionsForm).processing)
                            ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                                key: 0,
                                class: "animate-spin",
                                type: "mdi",
                                path: _unref(mdiLoading)
                              }, null, 8, ["path"]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" Lagre valg ")
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])),
    _createVNode(Confirm, {
      open: deleteAttributeConfirm.value,
      onDismiss: _cache[2] || (_cache[2] = ($event: any) => (deleteAttributeConfirm.value = false)),
      messages: ['Sletting av denne attibutten vil slette alle valgene og produkt variantene relatert den'],
      header: "Er du sikker du vil slette denne attributten?",
      url: _ctx.route('attributes.delete', {attribute: props.attribute.id}),
      action: "Slett"
    }, null, 8, ["open", "url"])
  ], 64))
}
}

})